import { LoadingComponent } from './../shared/components/loading/loading.component';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { AlertComponent } from '../shared/components/modais/alert/alert.component';
import { ConfirmComponent } from '../shared/components/modais/confirm/confirm.component';
import { PromptComponent } from '../shared/components/modais/prompt/prompt.component';
import { AlertPushComponent } from '../shared/components/modais/alert-push/alert-push.component';
import { ViaCep } from '../interfaces/viacep';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { FileSaverService } from 'ngx-filesaver';
import * as XLSX from 'xlsx';




@Injectable({
  providedIn: 'root'
})
export class AppService {

  api_cep = environment.api_cep;
  constructor(
    public modal: NgbModal,
    public auth: AuthService,
    public router: Router,
    public modalConfig: NgbModalConfig,
    private http: HttpClient,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private _FileSaverService: FileSaverService
  ) {
    this.modalConfig.backdrop = 'static';
  }

  alert(message: string | Array<string>, title: string = 'Alerta', options?: Array<any> | any) {
    const ref = this.modal.open(AlertComponent, options);
    ref.componentInstance.title = title;
    ref.componentInstance.setMessage(message);
    return ref.result;
  }

  confirm(message: string, title: string = 'Confirme',
    options: { text: string, value: any, cssClass: string }[] =
      [
        { text: 'Cancelar', value: false, cssClass: 'btn btn-link' },
        { text: 'Confirmar', value: true, cssClass: 'btn-primary' }
      ]) {
    const ref = this.modal.open(ConfirmComponent, { backdrop: 'static' });
    ref.componentInstance.setMessage(message);
    ref.componentInstance.title = title;
    ref.componentInstance.options = options;
    return ref.result;
  }

  prompt(message: string, title: string = 'Confirme', buttonSubmitText?) {
    const ref = this.modal.open(PromptComponent, { backdrop: 'static' });
    ref.componentInstance.setMessage(message);
    ref.componentInstance.title = title;
    ref.componentInstance.buttonSubmitText = buttonSubmitText;
    return ref.result;
  }

  toastSuccess(message: string) {
    this.toastr.success(message);
  }

  toastWarning(message: string) {
    this.toastr.warning(message, '', {
      enableHtml: true,
      progressBar: true,
      timeOut: 5000,
      extendedTimeOut: 5000
    });
  }

  toastInfo(message: string) {
    this.toastr.info(message);
  }

  toastError(message: string) {
    this.toastr.error(message);
  }

  // Mostra os erros da API ({ errors: [] }) ou uma mensagem padrão quando a resposta vem sem corpo
  tratarErro(erro: any, mensagemPadrao: string = 'Não foi possível concluir a operação. Tente novamente.') {
    console.error(erro);
    let errors = erro?.error?.errors;

    // Validação automática do ASP.NET devolve { Campo: ["mensagem"] }
    if (errors && !Array.isArray(errors) && typeof errors === 'object') {
      errors = Object.values(errors).reduce((lista: string[], mensagens) => lista.concat(mensagens as string[]), []);
    }

    if (Array.isArray(errors) && errors.length) {
      errors.forEach((item: string) => this.toastWarning(item));
      return;
    }

    this.toastWarning(mensagemPadrao);
  }

  // A API responde lista vazia como { success: true, data: "Nenhum ... encontrado." }
  normalizarLista<T = any>(resposta: any): T[] {
    return Array.isArray(resposta) ? resposta : [];
  }

  viaCep(cep) {
    return this.http.get<ViaCep>(`${this.api_cep}${cep}/json`).toPromise();
  }

  setAvatar(avatar: string) {
    if (avatar) {
      return `background-image: url(${avatar})`;
    }
    return `background-image: url('assets/user_avatar.png')`;
  }

  loadingShow() {
    this.spinner.show();
  }

  loadingHide() {
    this.spinner.hide();
  }

  converterDocumento(doc) {
    const documento = doc;
    if (documento.length == 11) {
      const cpf = documento.replace(/(\d{3})?(\d{3})?(\d{3})?(\d{2})/, "$1.$2.$3-$4");
      return cpf;
    } else if (documento.length == 14) {
      const cnpj = documento.replace(/(\d{2})?(\d{3})?(\d{3})?(\d{4})?(\d{2})/, "$1.$2.$3/$4-$5");
      return cnpj;
    }
  }

  abrirLinkDownload(url) {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.download = "";
    link.click();
  }

  orderByArray(array: any[], item: string) {
    return array.sort((a, b) => {
      a = a[item].toUpperCase();
      b = b[item].toUpperCase();

      if (a < b) {
        return - 1;
      }

      if (a > b) {
        return 1
      }

      return 0
    })
  }

  normalizeText(text) {
    let result = text.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
    return result;
  }

  validarSenha(senha: string) {
    const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!regex.test(senha)) {
      return false;
    }

    return true;
  }

  exportAsExcelFile(json: any[], excelFileName: string = 'excel'): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    this._FileSaverService.save(blob, `${excelFileName}.xlsx`);
  }
}
